export default __webpack_public_path__ + "img/cons.565b5825.png";